import styled from 'styled-components';
import { colors, devices } from '../../../../base/styled/variables.styled';
import { typography, fontWeights } from '../../../../base/styled/typography.style';
export const Container = styled.div.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1216px; // Standard container width usually
  margin: 0 auto;
  padding: 24px;
  box-sizing: border-box;
  background-color: ${({ $inverse }) => $inverse ? colors.neutral900 : colors.neutral000};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};

  @media ${devices.mobile} {
    padding: 16px;
    gap: 24px;
  }
`;
export const Header = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 24px;

  @media ${devices.mobile} {
    margin-bottom: 0px;
  }
`;
export const TitleWrapper = styled.h1 `
  ${typography.headline3}
  font-weight: ${fontWeights.regular};
  margin: 0;
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
  
  strong {
    font-weight: ${fontWeights.bold};
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
  }
`;
export const TabsWrapper = styled.div `
  width: 100%;
`;
export const ContentWrapper = styled.div `
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  align-items: start;
  padding: 40px 0;

  @media ${devices.tablets} {
    grid-template-columns: 280px 1fr;
    gap: 16px;
  }

  @media ${devices.mobile} {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;
export const LeftColumn = styled.div `
  display: flex;
  flex-direction: column;
  
  // Center on mobile if needed, or keep full width
  @media ${devices.tablets} {
    align-items: center;
  }
`;
export const RightColumn = styled.div `
  display: flex;
  flex-direction: column;
`;
export const RichTextWrapper = styled.div.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
  padding: 0;
  color: ${({ $inverse }) => $inverse ? colors.neutral200 : colors.neutral800};

  h2, h3, h4 {
    margin-bottom: 24px;
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
  }

  p {
    ${typography.body2};
    margin-bottom: 16px;
    line-height: 1.5;
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
  }

  a {
    color: ${colors.brand500};
    text-decoration: underline;
    &:hover {
      color: ${colors.brand700};
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
`;
export const ProgrammaticTitle = styled.h3 `
  ${typography.headline4};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
  margin-bottom: 16px;
`;
export const ProgrammaticList = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const ProgrammaticItem = styled.div `
  ${typography.body2};
  color: ${({ $inverse }) => $inverse ? colors.neutral200 : colors.neutral800};

  &:last-child {
    border-bottom: none;
  }
`;
//# sourceMappingURL=CourseDetail.style.js.map